module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_3.11b63b53.png";